import axios from 'axios'

export const MedPraxProductSearch = async (searchQuery, page, pageLimit) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      let response = null

      try {
        response = await axios.post(`${process.env.REACT_APP_NODE_RED_URL}/api/medprax/medicines`, {
          body: {
            filters: [
              {
                propertyName: 'name',
                operation: 'StartsWith',
                value: searchQuery
              },
              {
                propertyName: 'Code',
                operation: 'StartsWith',
                value: searchQuery
              },
              {
                propertyName: 'NappiCode',
                operation: 'StartsWith',
                value: searchQuery
              },
              {
                propertyName: 'Name',
                operation: 'Contains',
                value: searchQuery
              }
            ],
            filterJoin: 'Or',
            ascendingOrder: true,
            sortKey: 'code',
            proj: 'name'
          },
          pageLimit: 100,
          page: 1
        })
        resolve(response.data.products.pageResult)
      } catch (e) {
        reject(e)
      }
    })()
  })
}
